import React from "react";
import {useTranslation} from "react-i18next";

import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "materialDashboard/components/MDBox";


const CollectionsMenu = ({
                             profileName,
                             onNewCollection = f => f,
                             onDeleteCollection = f => f,
                             collectionType
                         }) => {
    const {t} = useTranslation(['models23']);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleAdd = () => {
        onNewCollection();
        handleClose();
    };

    const handleDelete = () => {
        onDeleteCollection();
        handleClose();
    };

    const buttonId = `menu-button-${profileName}`;
    const menuId = `menu-${profileName}`;

    return (
        <MDBox marginLeft="auto">
            <IconButton id={buttonId}
                        aria-controls={open ? menuId : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
            >
                <Icon fontSize="small">settings</Icon>
            </IconButton>
            <Menu id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                      'aria-labelledby': buttonId,
                  }}
                  anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                  }}
                  transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                  }}
            >
                <MenuItem onClick={handleAdd}>{t(collectionType ==='test' ? 'collectionsMenu.addTest' : 'collectionsMenu.addProfile')}</MenuItem>
                <MenuItem onClick={handleDelete}>{t(collectionType ==='test' ? 'collectionsMenu.deleteTest' : 'collectionsMenu.deleteProfile')}</MenuItem>
            </Menu>
        </MDBox>
    );
}

export default CollectionsMenu;